import { VERSION_MISMATCH } from './constants'

export const reportVersionMismatch = () => ({
  type: VERSION_MISMATCH,
})
